import { render, staticRenderFns } from "./CkEditorComponent.vue?vue&type=template&id=0aa8b52c"
import script from "./CkEditorComponent.vue?vue&type=script&lang=js"
export * from "./CkEditorComponent.vue?vue&type=script&lang=js"
import style0 from "./CkEditorComponent.vue?vue&type=style&index=0&id=0aa8b52c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports